module.exports = __webpack_public_path__ + "img/up_arrow_icon.9712a4e1.svg";